import { FormattedMessage } from "react-intl";
import {
  Button,
  makeStyles,
  tokens,
  mergeClasses,
} from "@fluentui/react-components";

import {
  Dialog,
  DialogTrigger,
  DialogSurface,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogBody,
} from "@fluentui/react-dialog";

import { ErrorCircleRegular } from "@fluentui/react-icons";

import { DIALOG_ACTIONS } from "./messages";

const useStyles = makeStyles({
  title: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  icon: {
    fontSize: "24px",
  },
  errorTitle: {
    color: tokens.colorPaletteRedForeground1,
  },
  errorIcon: {
    color: tokens.colorPaletteRedBorderActive,
  },
});

export interface PostMeetingNotEditableProps {
  onConfirm: () => void;
  onCancel: () => void;
}

export default function PostMeetingNotEditable({
  onConfirm,
  onCancel,
}: PostMeetingNotEditableProps) {
  const styles = useStyles();
  return (
    <Dialog open modalType="alert" onOpenChange={onCancel}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle
            className={mergeClasses(styles.title, styles.errorTitle)}
          >
            <ErrorCircleRegular
              className={mergeClasses(styles.icon, styles.errorIcon)}
            />
            <FormattedMessage
              defaultMessage="Profile Can Not Be Edited"
              description="Title of the dialog shown when the wrap-up was already edited in Connected and can no longer be saved from the app."
            />
          </DialogTitle>
          <DialogContent>
            <p>
              <FormattedMessage
                defaultMessage="We detected that the Post Meeting Activity information associated with this interview has been modified within Connected. Please make further edits directly on the Talent's Profile within Connected."
                description="First paragraph of the dialog shown when the wrap-up was already edited in Connected."
              />
            </p>
            <p>
              <FormattedMessage
                defaultMessage='Click "Confirm" to navigate to Connected and review the details, or "Cancel" to stay on this page.'
                description="Second paragraph of the dialog shown when the wrap-up was already edited in Connected; Confirm and Cancel are the dialog buttons."
              />
            </p>
          </DialogContent>
          <DialogActions>
            <Button appearance="primary" onClick={onConfirm}>
              <FormattedMessage {...DIALOG_ACTIONS.confirm} />
            </Button>
            <DialogTrigger>
              <Button appearance="secondary" onClick={onCancel}>
                <FormattedMessage {...DIALOG_ACTIONS.cancel} />
              </Button>
            </DialogTrigger>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}
